/**
 * Configuração centralizada de variáveis de ambiente
 * Garante acesso type-safe e validação de variáveis obrigatórias
 */

interface EnvConfig {
  apiBaseUrl: string;
}

/**
 * Obtém a URL base da API do ambiente
 * @returns URL base da API configurada
 */
function getApiBaseUrl(): string {
  const url = import.meta.env.VITE_API_BASE_URL;
  
  if (!url) {
    console.warn('VITE_API_BASE_URL não configurada, usando fallback: http://localhost:3000/api');
    return 'http://localhost:3000/api';
  }
  
  return url.replace(/\/+$/, '');
}

/**
 * Configuração de ambiente exportada
 */
export const env: EnvConfig = {
  apiBaseUrl: getApiBaseUrl(),
};

/**
 * Valida se todas as variáveis obrigatórias estão configuradas
 * Deve ser chamada no início da aplicação
 */
export function validateEnv(): void {
  if (!env.apiBaseUrl) {
    throw new Error('Configuração de ambiente inválida: VITE_API_BASE_URL é obrigatória');
  }
}
